module.exports = __webpack_public_path__ + "img/administration_block.303dec04.svg";